import { gql } from '@apollo/client';

const jumperViewItem = gql`
  fragment JumperViewItem on JumperView {
    id
    hasTerms
    hasPackages
    hasNotes
  }
`;

export const feedbackJumperFragments = gql`
  fragment FeedbackJumperFields on Jumper {
    id
    tag
    crimpTool
    connectionsMade
    installedTime
    installedBy
    inspectedTime
    inspectedBy
    constructionStatus
    updatedTime
    updatedBy
    updatedByUser {
      id
      nameFirst
      nameLast
      nameMiddle
      userAccountPhoto {
        id
        photo
      }
    }
    cableCode {
      numberOfConductors
      numberOfShields
      numberOfGrounds
    }
  }
`;
export const FEEDBACK_JUMPER = gql`
  mutation FeedbackJumper($feedbackJumperInput: FeedbackJumperInput!) {
    feedbackJumper(feedbackJumperInput: $feedbackJumperInput) {
      jumper {
        ...FeedbackJumperFields
      }
      errors
    }
  }
  ${feedbackJumperFragments}
`;
export const SEARCH_JUMPERS = gql`
  query searchJumpers($searchInput: SearchInput) {
    searchJumpers(searchInput: $searchInput) {
      items {
        ...FeedbackJumperFields
      }
    }
  }
  ${feedbackJumperFragments}
`;

export const jumperFragments = {
  jumperItem: gql`
    ${jumperViewItem}
    fragment JumperItem on Jumper {
      tag
      id
      cableCodeId
      cableCode {
        id
        tag
      }
      secondaryStatus
      drawing
      drawing2
      separationGroupId
      separationGroup {
        id
        name
      }
      disciplineCode
      safetyCode
      revision
      unit
      facility
      systemId
      system {
        id
        tag
      }
      startupSystemId
      startupSystem {
        id
        tag
      }
      crimpTool
      constructionStatus
      engineeringStatus
      primaryStatus
      holdStatus
      cardRev
      ownerId
      updatedBy
      updatedTime
      preparedBy
      preparedTime
      approvedBy
      approvedTime
      checkedBy
      checkedTime
      approvedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      checkedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      preparedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      updatedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      fromTermDrawing
      fromEquipmentId
      fromEquipment {
        id
        tag
      }
      toTermDrawing
      toEquipmentId
      toEquipment {
        tag
        id
      }
      misc1
      misc2
      misc3
      misc4
      misc5
      misc6
      misc7
      misc8
      misc9
      misc10
      misc11
      misc12
      misc13
      misc14
      misc15
      misc16
      misc17
      misc18
      misc19
      misc20
      miscDate1
      miscDate2
      isRestricted
      jumperView {
        ...JumperViewItem
      }
    }
  `,
};

export const CREATE_JUMPER = gql`
  ${jumperFragments.jumperItem}
  mutation CreateJumper($createJumperInput: CreateJumperInput!) {
    createJumper(createJumperInput: $createJumperInput) {
      jumper {
        ...JumperItem
      }
      errors
    }
  }
`;

export const DELETE_JUMPER = gql`
  mutation DeleteJumper($deleteJumperInput: DeleteJumperInput!) {
    deleteJumper(deleteJumperInput: $deleteJumperInput) {
      id
      errors
      infos
    }
  }
`;

export const UPDATE_JUMPER = gql`
  ${jumperFragments.jumperItem}
  mutation UpdateJumper($updateJumperInput: UpdateJumperInput!) {
    updateJumper(updateJumperInput: $updateJumperInput) {
      jumper {
        ...JumperItem
      }
      errors
    }
  }
`;

export const UPDATE_JUMPERS = gql`
  ${jumperFragments.jumperItem}
  mutation UpdateJumpers($updateJumpersInput: [UpdateJumperInput!]!) {
    updateJumpers(updateJumpersInput: $updateJumpersInput) {
      jumpers {
        ...JumperItem
      }
      infos {
        tag
        messageKeys
      }
      errors {
        tag
        messageKeys
      }
    }
  }
`;

export const GET_JUMPER_BY_ID = gql`
  ${jumperFragments.jumperItem}
  query JumperById($id: ID!) {
    jumperById(id: $id) {
      ...JumperItem
    }
  }
`;

export const GET_JUMPER_BY_IDS = gql`
  ${jumperFragments.jumperItem}
  query JumperByIds($ids: [ID!]!) {
    jumperByIds(ids: $ids) {
      ...JumperItem
    }
  }
`;

export const ISSUE_JUMPERS = gql`
  ${jumperFragments.jumperItem}
  mutation IssueJumpers($issueJumpersInput: [IssueJumperInput!]!) {
    issueJumpers(issueJumpersInput: $issueJumpersInput) {
      jumpers {
        ...JumperItem
      }
      errors {
        messageKeys
      }
    }
  }
`;

export const GET_JUMPER_STATS = gql`
  query JumperStats($jumperStatsInput: JumperStatsInput) {
    jumperStats(jumperStatsInput: $jumperStatsInput) {
      totalCount
      terminatedCount
      revisedCardCount
      onHoldCount
      preliminaryCount
      releasedCount
      jobsiteCount
      constructedCount
    }
  }
`;

export const GET_JUMPER_VIEW_STATS = gql`
  ${jumperViewItem}
  query GetJumperViewStats($id: ID!) {
    jumperById(id: $id) {
      id
      jumperView {
        ...JumperViewItem
      }
    }
  }
`;
